<template>
    <main class="J-dashboard-body">
        <div class="J-container-bar">
         
          <Transition name="slide-fade">
            <div class="J-sidebar-container" v-show="collapse">
                <div class="J-header-sidebar J-flex">
                    <div class="J-header-movil">
                        <div class="J-header-bar ">
                            <button type="button" class="J-btn-icon" @click="menuHeader()"> 
                                <i class="fa-solid fa-bars"></i>
                            </button>
                        </div>
                    </div>
                    
                </div>
              <div class="J-sidebar-content">
                <div class="J-sidebar">
                  <ul class="J-sidebar-list">
                      <!-- <li class="J-spacer"></li>-->
                      <li class="J-sidebar-list-item">
                          <router-link to="/dashboard" class="J-btn active">
                              <div class="J-btn--active">
                                <span class="J-btn--active-icon">
                                  <svg width="48" height="53" viewBox="0 0 48 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.96 3.49091H8.8C8.0672 3.49091 7.4368 3.49091 6.88 3.63404C6.01804 3.85873 5.22992 4.33936 4.60298 5.02268C3.97604 5.706 3.53475 6.56533 3.328 7.50546C3.2 8.11287 3.2 8.79709 3.2 9.6V18.3273C3.2 19.1267 3.2 19.8144 3.3312 20.4218C3.53717 21.3621 3.97775 22.2219 4.60413 22.9058C5.2305 23.5898 6.01822 24.0712 6.88 24.2967C7.4368 24.4364 8.064 24.4364 8.8 24.4364H16.8C17.5328 24.4364 18.1632 24.4364 18.72 24.2932C19.582 24.0685 20.3701 23.5879 20.997 22.9046C21.624 22.2213 22.0653 21.3619 22.272 20.4218C22.4 19.8144 22.4 19.1302 22.4 18.3273V9.6C22.4 8.80058 22.4 8.11287 22.2688 7.50546C22.0628 6.56513 21.6223 5.70537 20.9959 5.02143C20.3695 4.33749 19.5818 3.85609 18.72 3.63055C18.1632 3.49091 17.536 3.49091 16.8 3.49091H8.96ZM7.6256 7.03069C7.7632 6.99578 7.9776 6.98182 8.96 6.98182H16.64C17.6256 6.98182 17.8368 6.99229 17.9744 7.03069C18.2619 7.10568 18.5247 7.26607 18.7336 7.49406C18.9426 7.72205 19.0897 8.00874 19.1584 8.32233C19.1904 8.46895 19.2 8.69935 19.2 9.77455V18.1527C19.2 19.2279 19.1904 19.4583 19.1552 19.6084C19.0865 19.922 18.9394 20.2087 18.7304 20.4367C18.5215 20.6647 18.2587 20.8251 17.9712 20.9001C17.84 20.9315 17.6288 20.9455 16.64 20.9455H8.96C7.9744 20.9455 7.7632 20.935 7.6256 20.8966C7.33814 20.8216 7.07535 20.6612 6.86635 20.4332C6.65736 20.2052 6.51034 19.9185 6.4416 19.6049C6.4128 19.4618 6.4 19.2314 6.4 18.1527V9.77455C6.4 8.69935 6.4096 8.46895 6.4448 8.31884C6.51354 8.00525 6.66056 7.71856 6.86955 7.49057C7.07855 7.26258 7.34134 7.10219 7.6288 7.0272L7.6256 7.03069ZM31.36 3.49091H31.2C30.4672 3.49091 29.8368 3.49091 29.28 3.63404C28.418 3.85873 27.6299 4.33936 27.003 5.02268C26.376 5.706 25.9347 6.56533 25.728 7.50546C25.6 8.11287 25.6 8.79709 25.6 9.6V18.3273C25.6 19.1267 25.6 19.8144 25.7312 20.4218C25.9372 21.3621 26.3777 22.2219 27.0041 22.9058C27.6305 23.5898 28.4182 24.0712 29.28 24.2967C29.8368 24.4364 30.464 24.4364 31.2 24.4364H39.2C39.9328 24.4364 40.5632 24.4364 41.12 24.2932C41.982 24.0685 42.7701 23.5879 43.397 22.9046C44.024 22.2213 44.4653 21.3619 44.672 20.4218C44.8 19.8144 44.8 19.1302 44.8 18.3273V9.6C44.8 8.80058 44.8 8.11287 44.6688 7.50546C44.4628 6.56513 44.0223 5.70537 43.3959 5.02143C42.7695 4.33749 41.9818 3.85609 41.12 3.63055C40.5632 3.49091 39.936 3.49091 39.2 3.49091H31.36ZM30.0256 7.03069C30.1632 6.99578 30.3776 6.98182 31.36 6.98182H39.04C40.0256 6.98182 40.2368 6.99229 40.3744 7.03069C40.6619 7.10568 40.9247 7.26607 41.1336 7.49406C41.3426 7.72205 41.4897 8.00874 41.5584 8.32233C41.5904 8.46895 41.6 8.69935 41.6 9.77455V18.1527C41.6 19.2279 41.5872 19.4583 41.5552 19.6084C41.4865 19.922 41.3394 20.2087 41.1304 20.4367C40.9215 20.6647 40.6587 20.8251 40.3712 20.9001C40.2368 20.935 40.0256 20.9455 39.04 20.9455H31.36C30.3744 20.9455 30.1632 20.935 30.0256 20.8966C29.7381 20.8216 29.4753 20.6612 29.2664 20.4332C29.0574 20.2052 28.9103 19.9185 28.8416 19.6049C28.8128 19.4618 28.8 19.2314 28.8 18.1527V9.77455C28.8 8.69935 28.8096 8.46895 28.8448 8.31884C28.9135 8.00525 29.0606 7.71856 29.2696 7.49057C29.4785 7.26258 29.7413 7.10219 30.0288 7.0272L30.0256 7.03069ZM8.8 27.9273H16.8C17.5328 27.9273 18.1632 27.9273 18.72 28.0704C19.582 28.2951 20.3701 28.7757 20.997 29.459C21.624 30.1424 22.0653 31.0017 22.272 31.9418C22.4 32.5492 22.4 33.2335 22.4 34.0364V42.7636C22.4 43.5631 22.4 44.2508 22.2688 44.8582C22.0628 45.7985 21.6223 46.6583 20.9959 47.3422C20.3695 48.0261 19.5818 48.5076 18.72 48.7331C18.1632 48.8727 17.536 48.8727 16.8 48.8727H8.8C8.0672 48.8727 7.4368 48.8727 6.88 48.7296C6.01804 48.5049 5.22992 48.0243 4.60298 47.341C3.97604 46.6576 3.53475 45.7983 3.328 44.8582C3.2 44.2508 3.2 43.5665 3.2 42.7636V34.0364C3.2 33.2369 3.2 32.5492 3.3312 31.9418C3.53717 31.0015 3.97775 30.1417 4.60413 29.4578C5.2305 28.7739 6.01822 28.2924 6.88 28.0669C7.4368 27.9273 8.064 27.9273 8.8 27.9273ZM8.96 31.4182C7.9744 31.4182 7.7632 31.4287 7.6256 31.4671C7.33814 31.542 7.07535 31.7024 6.86635 31.9304C6.65736 32.1584 6.51034 32.4451 6.4416 32.7587C6.4128 32.9018 6.4 33.1322 6.4 34.2109V42.5891C6.4 43.6643 6.4096 43.8947 6.4448 44.0448C6.51354 44.3584 6.66056 44.6451 6.86955 44.8731C7.07855 45.1011 7.34134 45.2614 7.6288 45.3364C7.7632 45.3713 7.9744 45.3818 8.96 45.3818H16.64C17.6256 45.3818 17.8368 45.3679 17.9744 45.3329C18.2619 45.258 18.5247 45.0976 18.7336 44.8696C18.9426 44.6416 19.0897 44.3549 19.1584 44.0413C19.1904 43.8947 19.2 43.6643 19.2 42.5891V34.2109C19.2 33.1357 19.1904 32.9053 19.1552 32.7552C19.0865 32.4416 18.9394 32.1549 18.7304 31.9269C18.5215 31.6989 18.2587 31.5386 17.9712 31.4636C17.84 31.4321 17.6288 31.4182 16.64 31.4182H8.96ZM31.36 27.9273H31.2C30.4672 27.9273 29.8368 27.9273 29.28 28.0704C28.418 28.2951 27.6299 28.7757 27.003 29.459C26.376 30.1424 25.9347 31.0017 25.728 31.9418C25.6 32.5492 25.6 33.2335 25.6 34.0364V42.7636C25.6 43.5631 25.6 44.2508 25.7312 44.8582C25.9372 45.7985 26.3777 46.6583 27.0041 47.3422C27.6305 48.0261 28.4182 48.5076 29.28 48.7331C29.8368 48.8762 30.4672 48.8762 31.2 48.8762H39.2C39.9328 48.8762 40.5632 48.8762 41.12 48.7331C41.9814 48.5078 42.7688 48.0269 43.3952 47.3437C44.0215 46.6604 44.4623 45.8014 44.6688 44.8617C44.8 44.2543 44.8 43.5665 44.8 42.7671V34.0364C44.8 33.2369 44.8 32.5492 44.6688 31.9418C44.4628 31.0015 44.0223 30.1417 43.3959 29.4578C42.7695 28.7739 41.9818 28.2924 41.12 28.0669C40.5632 27.9273 39.936 27.9273 39.2 27.9273H31.36ZM30.0256 31.4671C30.1632 31.4321 30.3776 31.4182 31.36 31.4182H39.04C40.0256 31.4182 40.2368 31.4287 40.3744 31.4671C40.6619 31.542 40.9247 31.7024 41.1336 31.9304C41.3426 32.1584 41.4897 32.4451 41.5584 32.7587C41.5904 32.9053 41.6 33.1357 41.6 34.2109V42.5891C41.6 43.6643 41.5872 43.8947 41.5552 44.0448C41.4865 44.3584 41.3394 44.6451 41.1304 44.8731C40.9215 45.1011 40.6587 45.2614 40.3712 45.3364C40.2368 45.3713 40.0256 45.3818 39.04 45.3818H31.36C30.3744 45.3818 30.1632 45.3679 30.0256 45.3329C29.7381 45.258 29.4753 45.0976 29.2664 44.8696C29.0574 44.6416 28.9103 44.3549 28.8416 44.0413C28.8128 43.8982 28.8 43.6678 28.8 42.5891V34.2109C28.8 33.1357 28.8096 32.9053 28.8448 32.7552C28.9135 32.4416 29.0606 32.1549 29.2696 31.9269C29.4785 31.6989 29.7413 31.5386 30.0288 31.4636L30.0256 31.4671Z" fill="#9897AA"/>
                                  </svg>
                                  </span>
                                  <div  class="J-sidebar-list-item-title">
                                    Dashboard
                                  </div>
                              </div>
                          </router-link>
                      </li>
                      <li class="J-sidebar-list-item" v-for="(item,i) in menu" :key="i+1" v-show="item.roles.includes(user.rol)">
                          <router-link :to="item.to" class="J-btn">
                              <div class="J-btn--active ">
                                <span class="J-btn--active-icon">
                                    <i :class="item.icon"></i>
                                </span>
                                <div class="J-sidebar-list-item-title">
                                    {{ item.title }}
                                </div>
                              </div>
                              
                          </router-link>
                      </li>
                  </ul>
                  <ul class="J-sidebar-list">
                      <li class="J-sidebar-list-item">
                          <button class="J-btn J-m-b-0 svg-border" @click="logout()">
                              <div class="J-btn--active">
                                  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M22 2L16 8H8V16L2 22L8 28V36H16L22 42L28 36H36V28L42 22L36 16V8H28L22 2Z" stroke="#9897AA" stroke-width="4" stroke-linejoin="round"/>
                                      <path d="M22 28C23.5913 28 25.1174 27.3679 26.2426 26.2426C27.3679 25.1174 28 23.5913 28 22C28 20.4087 27.3679 18.8826 26.2426 17.7574C25.1174 16.6321 23.5913 16 22 16C20.4087 16 18.8826 16.6321 17.7574 17.7574C16.6321 18.8826 16 20.4087 16 22C16 23.5913 16.6321 25.1174 17.7574 26.2426C18.8826 27.3679 20.4087 28 22 28Z" stroke="#9897AA" stroke-width="4" stroke-linejoin="round"/>
                                  </svg>
                                      
                              </div>
                          </button>
                      </li>
                  </ul>
                </div>
              </div>
            </div>
          </Transition>
          <div class="J-container-full" :class="{'full': !collapse}">
            <div class="J-header" :class="{'full': !collapse}">
                <div class="J-header-left">
                    <button type="button" class="J-btn-icon" @click="menuHeader()"> 
                        <i class="fa-solid fa-bars"></i>
                    </button>
                </div>
                <!-- <div class="J-header-search">
                    <input type="search" class="J-form-search" name="" id="">
                </div> -->
                <div class="J-header-right">
                    
                    <button type="button" class="J-btn-icon"> 
                        <i class="fa-regular fa-bell"></i>
                    </button>
                    <button type="button" class="J-btn-icon"> 
                        <i class="fa-solid fa-envelope"></i>
                    </button>
                    <button type="button" class="J-btn-icon"> 
                        <i class="fa-solid fa-flag"></i>
                    </button>
                    <div class="dropdown">
                        <button class="btn btn-danger dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="fa-regular fa-user"></i>
                        </button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Datos</a></li>
                            <li><a class="dropdown-item" href="#" @click="logout()">Salir</a></li>
                        </ul>
                    </div>
                </div>
            </div>
             <div class="J-container-main J-flex column row-start">
                <!-- <BreadcrumbPartials></BreadcrumbPartials> -->
                <div class="J-container-content"> 
                  <router-view/>
                </div>
             </div>
          </div>
      </div>
    </main>
</template>
<script>
// import { useIpcRenderer } from '@vueuse/electron'
// const ipcRenderer = useIpcRenderer()
import BreadcrumbPartials from "@/components/partials/Breadcrumb.partial.vue";
import { ReportService } from '@/services';

export default {
    name: 'DefaultLayout',
    props: {
        
    },
    components:{
        BreadcrumbPartials,
    },
    data: ()=>({
        user:null,
        collapse:true,
        menu:[
            
            {
                title:"Usuario",
                to:"/users",
                roles: ["user","superadmin"],
                icon: "fa-solid fa-users",
            },
            {
                title:"Productos",
                to:"/product",
                roles: ["user","superadmin"],
                icon: "fa-solid fa-file-lines",
            },
            {
                title:"Categoria",
                to:"/category",
                roles: ["user","superadmin"],
                icon: "fa-solid fa-file-lines",
            },
            {
                title:"Cotization",
                to:"/cotization",
                roles: ["user","superadmin"],
                icon: "fa-solid fa-list-check",
            },
            {
                title:"Reporte",
                to:"/client",
                roles: ["user","superadmin"],
                icon: "fa-solid fa-file-lines",
            },
            // {
            //     title:"Reporte",
            //     to:"/report",
            //     roles: ["user","superadmin"],
            //     icon: "fa-solid fa-file-lines",
            // },
        ],
        window:{
        isMaxi:false,
        }
    }),
    created(){
        var user=JSON.parse(window.localStorage.getItem('user'))
        this.user=user;
        console.log(this.user)
        this.loadReport()
    },
    methods:{
        async loadReport(){
            await ReportService.list({});
        },
        menuHeader(){
            this.collapse=!this.collapse
        },
        logout(){
            localStorage.removeItem("token")
            localStorage.removeItem("user")
            this.$router.push('/')
        },  
        minus(){
        //   ipcRenderer.send('windows:minus','')
        },
        restore(){
        //   ipcRenderer.send('windows:restore','')
        this.window.isMaxi=true;
        },
        maxi(){
        //   ipcRenderer.send('windows:maxi','')
        this.window.isMaxi=false;
        },
        close(){
        //   ipcRenderer.send('windows:close','')
        }
    }
}
</script>